import { Box, Button, Card, CardContent, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { MyListApi } from "../../utils/restApi";
import { useSelector } from "react-redux";
import { ItemList2 } from "../ItemList2";
import { useNavigate } from "react-router-dom";

export const SiteTickets = () => {

    const user = useSelector(state => state.login.user);
    const [items, setItems] = useState([]);
    const navigate = useNavigate();
    // console.log('user', user);

    useEffect(() => {
        MyListApi.getItems3({
            userId: null,
            tag: 'site-tickets',
        }).then(data => {
            // console.log('data', data);
            setItems(data.data.items);
        }).catch(error => {
            // console.log('error', error);
        });
    }, []);

    const handleCreateItem = () => {
        navigate('/create-item?tag=site-tickets');
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {user ?
                <Card>
                    <CardContent>
                        <Button onClick={handleCreateItem} variant="contained">Create Item</Button>
                    </CardContent>
                </Card>
            : null}
            <ItemList2 items={items} />
        </Box>
    )
}